module.exports = __webpack_public_path__ + "img/main-bg.7a0af591.jpg";